// AUTO-GENERATED by scripts/generate-catalog-shards.mjs — do not edit.
// Re-run `npm run dev` or `npm run build` to refresh.
export const TOTAL_CAMERAS = 65943;
export const TOTAL_MANUFACTURERS = 307;
